import { render, staticRenderFns } from "./MiDomicilio.vue?vue&type=template&id=80bea012"
import script from "./MiDomicilio.vue?vue&type=script&lang=js"
export * from "./MiDomicilio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports